export {LoaderOptions} from './loaders/loader-options.interface';
export {
    BaseMapComponent,
    MapComponent,
    MapDirectionsDirective,
    MapMakerDirective,
    MapPolylineDirective,
    IOptionalSetMapMethod
} from './directives';
export {
    BaseMapsApiLoader,
    LAZY_LOADER_OPTIONS,
    LazyMapsApiLoader,
    HereMapsManager,
    NoopMapsApiLoader,
    Animation,
    IAnimation,
    ZoomLevel,
    IZoomLevel,
    LatLng,
    GeoPoint,
    MarkerOptions,
    PolylineOptions,
    MapUIService
} from './services';

export {HereMapsModule} from './here-maps.module';
